<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="区域财务调整"
      width="560px"
      top="12vh"
      append-to-body
      @close="$reset('form')">
    <el-form ref="form" :model="form" :rules="ruleValidate" label-width="110px">
      <el-form-item label="区域" prop="departmentName">
        <div style="display: flex;flex-direction: row;">
          <el-input v-model="form.departmentName" placeholder="请输入" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.selectDepartment.open()">选择区域</el-button>
          </el-input>
          <department-select ref="selectDepartment" @select="selectDepartment"/>
        </div>
      </el-form-item>
      <el-form-item label="期间" prop="periodDate">
        <el-date-picker
            v-model="form.periodDate"
            value-format="yyyy-MM-dd"
            type="month"
            placeholder="选择期间"
            style="width: 100%"/>
      </el-form-item>
      <el-form-item label="调整类型" prop="adjustType">
        <el-select v-model="form.adjustType" placeholder="请选择" style="width: 100%">
          <el-option :value="1" label="增加"/>
          <el-option :value="2" label="减少"/>
        </el-select>
      </el-form-item>
      <el-form-item label="调整金额(万元)" prop="adjustAmount">
        <el-input-number v-model="form.adjustAmount" :precision="2" :min="0" :controls="false" style="width: 100%"/>
      </el-form-item>
      <el-form-item label="调整原因" prop="reason">
        <el-input v-model="form.reason" type="textarea" :rows="2" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";

  export default {
    name: "RegionalAdjustEdit",
    components: {DepartmentSelect},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        form: {
          pkid: null,
          departmentId: null,
          departmentName: "",
          periodDate: "",
          adjustType: 1,
          adjustAmount: 0,
          reason: "",
        },
        ruleValidate: {
          departmentName: {required: true, message: "请选择区域", trigger: "blur"},
          periodDate: {required: true, message: "请选择期间", trigger: "change"},
          adjustType: {required: true, message: "请选择调整类型", trigger: "change"},
          reason: {required: true, message: "请填写调整原因", trigger: "blur"},
        },
      };
    },
    methods: {
      open(option) {
        this.form.pkid = null;
        this.form.departmentId = null;
        this.form.departmentName = "";
        this.form.periodDate = "";
        this.form.adjustType = 1;
        this.form.adjustAmount = 0;
        this.form.reason = "";
        // 支持从列表源数据预填（option: {departmentId, departmentName, periodDate}）
        if (option) {
          this.form.departmentId = option.departmentId != null ? option.departmentId : null;
          this.form.departmentName = option.departmentName || "";
          this.form.periodDate = option.periodDate || "";
        }
        this.dialogVisible = true;
      },
      selectDepartment(row) {
        this.form.departmentId = row.departmentID;
        this.form.departmentName = row.departmentName;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (!valid) {
            return;
          }
          this.submitLoading = true;
          this.$http
            .post("basic", "sd/salesRevenueReport/regionalAdjust", this.form)
            .then(resp => {
              this.submitLoading = false;
              if (resp && resp.success === false) {
                return this.$message.error(resp.message || "保存失败");
              }
              this.dialogVisible = false;
              this.$message.success("保存成功");
              this.$emit("save-success");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
